import { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { messageFor, oneidStartUrl, oneidStatus, takePendingError } from "../services/auth";

/**
 * Sign in.
 *
 * One control on the whole screen. Password login was removed by BLAC-123 --
 * OneID is the only way in, with no fallback -- so there is no form here and
 * nothing to validate.
 *
 * What this screen offers is decided by the server, not by this file. Until
 * GET /auth/oneid/status/ answers we render no button: guessing would mean
 * showing a OneID button during a OneID outage. A brief blank beats a control
 * that cannot work.
 */
const SignInLayer = () => {
  const [status, setStatus] = useState(null);
  // Survives the redirect that raised it: OneID sends failures back as a
  // fragment on the panel's own origin, long before this screen mounts.
  const [error] = useState(() => takePendingError());

  useEffect(() => {
    let live = true;
    oneidStatus()
      .then((s) => live && setStatus(s))
      .catch(
        // The server is unreachable. There is no second way in to fall back to,
        // so say so rather than drawing a button that cannot work.
        () => live && setStatus({ oneid_enabled: false, oneid_reason: "unreachable" }),
      );
    return () => {
      live = false;
    };
  }, []);

  const canSignIn = status?.oneid_enabled === true;
  const reason = status && !status.oneid_enabled ? status.oneid_reason : "";
  const reasonText =
    reason === "unreachable"
      ? "Serverga ulanib boʻlmadi."
      : reason === "disabled"
        ? messageFor("oneid_disabled")
        : reason === "unconfigured"
          ? messageFor("oneid_unconfigured")
          : "";

  return (
    <section className="fa">
      <main className="fa-form-side">
        <div className="fa-form-wrap">
          <span className="fa-lockup" style={{ "--i": 0 }}>
            <b>MySuhbat</b>
            <span>Boshqaruv</span>
          </span>

          <h1 className="fa-h" style={{ "--i": 1 }}>
            Tizimga kirish
          </h1>
          <p className="fa-p" style={{ "--i": 2 }}>
            Kirish faqat OneID orqali
          </p>

          {(error || reasonText) && (
            <div className="fa-error" role="alert">
              <Icon icon="solar:danger-triangle-linear" />
              {error || reasonText}
            </div>
          )}

          {canSignIn && (
            <button
              type="button"
              className="fa-submit"
              style={{ "--i": 3 }}
              onClick={() => {
                // A full-page navigation, not a fetch: the person authenticates
                // on sso.egov.uz, which is a different origin with its own UI.
                window.location.href = oneidStartUrl();
              }}
            >
              OneID orqali kirish
              <Icon icon="lucide:arrow-right" />
            </button>
          )}

          <p className="fa-help" style={{ "--i": 4 }}>
            Eslab qoladigan parol yoʻq, yoʻqotadigan parol ham yoʻq.
          </p>
        </div>
      </main>
    </section>
  );
};

export default SignInLayer;
